import { ChangeDetectionStrategy, Component, input, linkedSignal } from '@angular/core';
import { ResolvableModal } from '@softline/ui-core';
import { KommissionsauftragBewe } from '../../types/kommissionsauftrag';
import { MengenEingabeComponent } from '@softline/application';
import { unitEntryModalFn } from '@softapps/wws/core';

@Component({
  selector: 'soft-quantity-input-modal',
  imports: [MengenEingabeComponent],
  templateUrl: './quantity-input-modal.html',
  styleUrl: './quantity-input-modal.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuantityInputModal extends ResolvableModal<
  KommissionsauftragBewe | undefined
> {
  readonly bewekomm = input.required<KommissionsauftragBewe>();
  readonly quantity = linkedSignal(() => this.bewekomm()?.artikelMengeOffen?.menge ?? 0);
  protected readonly Number = Number;

  protected readonly unitEntry = unitEntryModalFn();

  close(): void {
    this.resolve({
      ...(this.bewekomm() as KommissionsauftragBewe),
      artikelMengeOffen: {
        ...this.bewekomm().artikelMengeOffen,
        menge: this.quantity() ?? 0,
      },
    });
  }

  async openUnitEntryModal(): Promise<void> {
    const result = await this.unitEntry({
      params: {
        idartstamm: this.bewekomm().artikelMengeOffen.artikel.id,
        idarteheingabe: this.bewekomm()?.artikelMengeOffen.idarteheingabe,
        idbasisEinheit:
          this.bewekomm()?.artikelMengeOffen?.einheit?.id ??
          this.bewekomm()?.artikelMengeOffen.einheit_lg.id,
        menge: 0,
      },
      dismiss: true,
      title: 'Einheiteneingabe',
    });

    if (!result || result === 'DISMISSED') return;
    this.quantity.set(result.summeEinheit.menge ?? result.erfassungsEinheit.menge ?? 0);
  }
}
